import dayjs from 'dayjs';
import {
  alias,
  custom,
  deserialize,
  list,
  object,
  optional,
  serializable,
  SKIP,
} from 'serializr';
import { Base } from './base.model';
import { Browser } from './browser.model';
import { PageObject } from './page-object.model';
import { System } from './system.model';
import { AgentType } from '@modules/agent/enums/agent-type.enum';
import { AgentLogLevel } from '@modules/agent/enums/agent-log-level.enum';

export class Agent extends Base implements PageObject {
  @serializable
  public agentVersion: string;
  @serializable(alias('browserList', optional(list(object(Browser)))))
  public browsers: Browser[];
  @serializable
  public currentAgentVersion: string;
  @serializable
  public enabled: boolean;
  @serializable
  public visibleToAll: boolean;
  @serializable
  public activateLater: boolean;
  @serializable
  public uniqueId: string;
  @serializable(object(System))
  public system: System;
  @serializable
  public createdById: number;
  @serializable
  public updatedAtEpoch: Date;
  @serializable
  public createdAtEpoch: Date;
  @serializable
  public jwtApiKey: string;
  @serializable
  public isLocalAgent: boolean = false;
  @serializable
  public status: string;
  @serializable
  public isDocker: boolean;
  @serializable
  public isService: boolean;
  @serializable
  public isInstaller: boolean;
  @serializable
  public isObsolete: boolean;
  @serializable(alias('isActive'))
  public active: boolean;
  @serializable
  public customBuild: string;
  @serializable
  public currentTimeStamp: Date;
  @serializable
  public maxSessions: number;
  @serializable
  public agentType: AgentType;
  @serializable
  public logLevel: AgentLogLevel;
  @serializable(
    alias(
      'goIosEnabled',
      custom(
        () => SKIP,
        (v) => v,
      ),
    ),
  )
  public goIosEnabled: boolean;

  // @ts-ignore
  get name(): string {
    return this.system.title;
  }

  get isActive(): boolean {
    return this.isOnline() && !this.isOutOfSync();
  }

  get isActivated(): boolean {
    return this.status == 'ACTIVATED';
  }

  get isRegistered(): boolean {
    return this.status == 'REGISTERED';
  }

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Agent, input));
  }

  isActiveForTwentyMinutes(): boolean {
    return (
      dayjs(this.updatedAt) >
      dayjs(this.currentTimeStamp).subtract(20, 'minute')
    );
  }

  isOnline(): boolean {
    return (
      this.active &&
      dayjs(this.updatedAt) > dayjs(this.currentTimeStamp).subtract(1, 'minute')
    );
  }

  isOutOfSync(): boolean {
    return this.agentVersion != this.currentAgentVersion;
  }
}
